import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {APIMETHOD, ConnectorType, IDataSourceSchema, IFieldShema, IRowAction, RowActionType} from '@usteknoloji/noosgrid';
import {IDialogDatasetSelectData, IDialogDatasetSelectReturn, IHttpSetting} from '../../../interface/dataset-params';
import {GlobalObjectService} from '../../../class/global-obj';
import {HttpFormDataService} from '../../../services/services';
import {FormComponent} from '../../form/form.component';
import {IFormSavingData} from '../../../interface/form-structure';
import {ActionFlag, IFormDialogData} from '../../../interface/component';

@Component({
    selector: 'noos-dialog-dataset-select',
    templateUrl: './dialog-dataset-select.component.html',
    styleUrls: ['./dialog-dataset-select.component.scss']
})
export class DialogDatasetSelectComponent implements OnInit {


    fieldList: IFieldShema[] = [];
    actionList: IRowAction[] = [];
    gridData: IDataSourceSchema;
    searchText = '';

    isDialog = true;
    defaultFormId: 0;

    constructor(public dialogRef: MatDialogRef<DialogDatasetSelectComponent>, private dialog: MatDialog,
                @Inject(MAT_DIALOG_DATA) public data: IDialogDatasetSelectData, private fService: HttpFormDataService) {
    }

    ngOnInit() {

        this.loadDatasetInfo(this.data.dataset_id);
        // this.loadGrid();

        this.actionList = [
            {
                type: RowActionType.EVENT,
                list_order: 1,
                title: 'SEÇ',
                event: {
                    event_code: 'select'
                }
            }
        ];


    }

    loadDatasetInfo(datasetId): void {
        this.fService.datasetInfo(datasetId).subscribe(ret => {
            console.log('DatasetInfo:', ret);
            if (ret.complete) {
                this.defaultFormId = ret.data.default_form_id;
            }
        });
    }

    loadGrid(e = '') {
        const setting: IHttpSetting = GlobalObjectService.getVar('setting');
        this.gridData = {
            connector: {
                type: ConnectorType.LIVE,
                live: {
                    method: APIMETHOD.POST,
                    api_url: setting.urls,
                    params: [
                        {key: 'search', value: this.searchText},
                        {key: 'dsid', value: this.data.dataset_id},
                        {key: 'trigger', value: {_sdsid: this.data.target_dataset_id, _sfield: this.data.target_field_name}},
                        {key: 'shadow', value: this.data.shadowFieldValues}
                    ]
                }
            },
            data: []
        };

    }

    onNoClick() {
        this.dialogRef.close();
    }

    onRowAction($event) {
        if ($event.key_field) {
            const response: IDialogDatasetSelectReturn = {
                id: $event.key_field.value,
                title: $event.title
            };

            this.dialogRef.close(response);
        }

    }

    onKeydown($event: any) {

        this.loadGrid();

    }

    newRecord() {

        const setting: IHttpSetting = GlobalObjectService.getVar('setting');
        const dialogData: IFormDialogData = {
            setting: {urls: setting.urls, env: setting.env},
            formId: this.defaultFormId,
            formJson: null,
            actionFlag: ActionFlag.NEW,
            API_URLS: null,
            workFlowObjectId: ''
        };

        const dialogRef = this.dialog.open(FormComponent, {
            width: '900px',
            panelClass: 'formDialog',
            data: JSON.parse(JSON.stringify(dialogData)),
            autoFocus: false
        });


        dialogRef.afterClosed().subscribe((result: IFormSavingData) => {
            if (result) {
                this.loadGrid();
            }
        });
    }
}
